export default __webpack_public_path__ + "static/3-33eb2c8cd94c248de43cf6b05180ad16.jpg";